import LogRocket from 'logrocket';

import type { AnalyticsProperties, AnalyticsSink } from '../types';

/** Drop empty/falsy values, matching legacy `LogRocket.track` payload filtering. */
const filterEmpties = (obj: AnalyticsProperties): AnalyticsProperties =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => !!value));

/**
 * LogRocket product-event sink. LogRocket user identity is handled by the
 * observability LogRocket sink, so {@link AnalyticsSink.identify} is a no-op here.
 */
export function createLogRocketTrackSink(): AnalyticsSink {
  return {
    name: 'LOGROCKET',

    track(event: string, properties: AnalyticsProperties = {}) {
      // SAFETY: AnalyticsPropertyValue only contains values accepted by LogRocket.track.
      LogRocket.track(event, filterEmpties(properties) as Parameters<typeof LogRocket.track>[1]);
    },

    identify() {
      // LogRocket identity is owned by the observability LogRocket sink.
    },
  };
}
